export default "__VITE_PUBLIC_ASSET__4cd3ad30__"